import DashboardIcon from "../icons/DashboardIcon"

export default {
    icon: DashboardIcon,
    layout: "dashboard",
    url: "/",
    title: "Dashboard"
}